import { useMemo } from "react";
import { PANEL_DIVIDER_PX, usePanelWidths, type PanelWidthsConfig } from "@/shared/ui/panelWidths";

/**
 * Larghezze persistite delle colonne della pagina Mail — proposta A
 * (2026-07-02): lista outbox | thread fluido | contesto ordine, con le
 * stesse meccaniche di resize della pagina Messaggi.
 */
export const MAIL_PANEL_DEFAULTS = {
  list: 320,
  context: 300,
} as const satisfies Record<string, number>;

export type MailPanelKey = keyof typeof MAIL_PANEL_DEFAULTS;

export const MAIL_PANEL_BOUNDS: Record<MailPanelKey, { min: number; max: number }> = {
  list: { min: 240, max: 500 },
  context: { min: 220, max: 460 },
};

export const MAIL_PANEL_STORAGE_KEY = "om.mail.panel-widths.v1";

const CONFIG: PanelWidthsConfig<MailPanelKey> = {
  storageKey: MAIL_PANEL_STORAGE_KEY,
  defaults: MAIL_PANEL_DEFAULTS,
  bounds: MAIL_PANEL_BOUNDS,
};

export function useMailPanelWidths(): {
  widths: Record<MailPanelKey, number>;
  setWidth: (key: MailPanelKey, px: number) => void;
  resetWidth: (key: MailPanelKey) => void;
  gridTemplateColumns: string;
} {
  const { widths, setWidth, resetWidth } = usePanelWidths(CONFIG);

  const gridTemplateColumns = useMemo(
    () =>
      [
        `${widths.list}px`,
        `${PANEL_DIVIDER_PX}px`,
        "minmax(0, 1fr)",
        `${PANEL_DIVIDER_PX}px`,
        `${widths.context}px`,
      ].join(" "),
    [widths],
  );

  return { widths, setWidth, resetWidth, gridTemplateColumns };
}
